import { combineReducers } from 'redux';

import { IQualityReport } from '@travelnest/typewriter';
import { Actions, ActionTypes } from './actions';

interface IQualityByPropertyId { [propertyId: string]: { [channelId: string]: IQualityReport }; }

export const byPropertyId = (state = {} as IQualityByPropertyId, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.QUALITY_GET_BY_PROPERTY_ID_RECEIVE:
			const existing = state[action.payload.quality.document_id] || {};
			return {
				...state,
				[action.payload.quality.document_id]: {
					...existing,
					[action.payload.quality.channel]: action.payload.quality
				}
			};
		default:
			return state;
	}
};

export interface IPropertiesState {
	byPropertyId: ReturnType<typeof byPropertyId>;
}

export default combineReducers<IPropertiesState>({
	byPropertyId
});
